'use client';

import { usePrevious } from './usePrevious';

/* i simply these functions for debuging. they help identify which value is cusing a useEffect, useCallback, ...hook
  is causing a them to re trigger. i usually use them like the following

```
  console.log(
  'some kind of identifier',
  Hooks.useCompareObject({ focusInput, 'props.onExpressionUpdate': props.onExpressionUpdate, setState }),
);
```
*/
export const useCompare = (args: unknown[]): boolean[] => {
  const prev = usePrevious(args);
  if (prev) {
    return args.map((value, index) => value === prev[index]);
  } else {
    return new Array(args.length).map(() => false);
  }
};

export const useCompareChangedOnly = <T extends string>(args: unknown[], names?: T[]): Record<T | number, unknown> =>
  useCompare(args).reduce<Record<T | number, unknown>>(
    (acc, v, i) => (v ? acc : { ...acc, [names?.[i] ?? i]: args[i] }),
    {} as Record<T | number, unknown>,
  );

export const useCompareObject = <T extends Record<string, unknown>>(args: T): Partial<T> =>
  useCompareChangedOnly(Object.values(args), Object.keys(args) as string[]) as Partial<T>;
